export default __webpack_public_path__ + "static/media/PF.b43bc02e.svg";